import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    name: {
        name: () => '参数名称',
        required: () => true,
    },

    dataTypeGrpCode: {
        name: () => '类型组别',
        required: () => true,
    },

    dataType: {
        name: () => '数据类型',
        required: () => true,

        validate: (map, node) => {
            const {dataTypeCode, dfDtoCode} = node.data

            if (! (dataTypeCode || dfDtoCode)) {
                return '数据类型不能为空'
            }
        }
    },

    remark: {
        name: () => '参数说明',
    },
})
